export const IS_ANDROID = /Android/i;
export const IS_IOS = /iPhone|iPad|iPod/i;
export const IS_BLACKBERRY = /BlackBerry/i;
export const IS_OPERA_MINI = /Opera Mini/i;

export const IS_WINDOWS_MOBILE_1 = /IEMobile/i;
export const IS_WINDOWS_MOBILE_2 = /WPDesktop/i;

export const IS_EDGE = /Edge/i;
